import { useLocation } from "react-router-dom";
import notification from "../../assets/admin/notification.svg";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import defaultImage from "../../utils/DefaultImage";

const Header = ({ setShowSidebarForMobile, showSidebarForMobile, logo, userName }) => {
  const location = useLocation();
  const [role, setRole] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [consoleType, setConsoleType] = useState("");

  useEffect(() => {
    const storedRole = localStorage.getItem("Role");
    setRole(storedRole);

    if (storedRole === "admin") {
      setConsoleType("Admin Console");
    } else if (storedRole === "restaurant") {
      setConsoleType("Restaurant Console");
    }

    setShowAlert(true);
  }, [location.pathname]);
  return (
    <>
      <div className="flex justify-between w-full tems-center mt-5 mb-5 gap-x-3 relative">
        <div className="head-title-jumbar flex items-center justify-start gap-x-4">
          {role && showAlert && (
            <div
              className="sm:top-[-50px] top-[-40px]  py-1 text-xs w-[210px] sm:w-[270px] sm:text-center text-center absolute translate-x-[-50%] left-[50%] mt-3 p-2 sm:text-sm text-blue-800 rounded-lg bg-blue-50 poppins-regular z-0"
              role="alert"
            >
              You are in
              <span className="font-medium poppins-regular"> {consoleType}</span>
            </div>
          )}
          <div
            className="humbar-bar"
            id="humbar-mobile"
            onClick={() => {
              setShowSidebarForMobile(!showSidebarForMobile);
            }}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          {location.pathname === "/admin/dashboard" && userName && (
            <h2 className="md:text-3xl sm:text-lg text-xs leading-5 font-bold poppins-medium sm:text-left text-center flex items-center">
              Ciao {userName}
            </h2>)}
        </div>
        {!localStorage.getItem("accessToAdmin") && (
          <div className="flex justify-end  items-center space-x-4">
            <img
              src={logo ? logo : defaultImage}
              alt=""
              className="w-10 h-10 rounded-full"
            />
            <button className="text-red-700">
              <img src={notification} height={20} width={20} />
            </button>
          </div>
        )}
      </div>
    </>
  );
};

Header.propTypes = {
  showSidebarForMobile: PropTypes.bool.isRequired,
  setShowSidebarForMobile: PropTypes.func.isRequired,
};

export default Header;
